import React from "react";
import DOMPurify from "dompurify";
import { resolveImage } from "../../../lib/cms";
import { fmtDate } from "../ui";
import { Label } from "./cmsShared";

function Row({ who, when, label }) {
  if (!who) return null;
  return (
    <li className="flex justify-between gap-3 py-2">
      <span className="text-stonegrey">{label}</span>
      <span className="text-right text-sapphire-deep">{who}<br /><span className="text-[11px] text-stonegrey">{fmtDate(when, true)}</span></span>
    </li>
  );
}

export function AuditTrail({ item }) {
  const p = item.published || {};
  const d = item.draft || p.audit || {};
  return (
    <div data-testid="cms-audit">
      <Label>Accountability</Label>
      <ul className="divide-y divide-sapphire-deep/5 font-sans text-xs">
        <Row label="Draft created" who={d.created_by_name || d.created_by} when={d.created_at} />
        <Row label="Submitted" who={d.submitted_by_name} when={d.submitted_at} />
        <Row label="Reviewed" who={d.reviewed_by_name} when={d.reviewed_at} />
        <Row label="Restored" who={d.restored_by_name} when={d.restored_at} />
        <Row label="Last published" who={p.published_by_name || p.published_by} when={p.published_at} />
      </ul>
    </div>
  );
}

export function Preview({ item, data }) {
  if (item.type === "article") {
    return (
      <article data-testid="cms-preview">
        {data.cover_image && <img src={resolveImage(data.cover_image)} alt="" className="mb-4 aspect-[16/9] w-full rounded-xl object-cover" />}
        <h3 className="font-display text-2xl font-semibold text-sapphire-deep">{data.title}</h3>
        <p className="mt-1 font-sans text-xs uppercase tracking-widest text-gold-deep">{data.publish_date}</p>
        <p className="mt-3 font-sans text-sm italic text-charcoal/70">{data.excerpt}</p>
        <div className="prose-article mt-4 text-sm" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data.body || "") }} />
      </article>
    );
  }
  if (data.items) {
    return (
      <ul className="space-y-3" data-testid="cms-preview">
        {data.items.map((it, i) => (
          <li key={i} className="rounded-lg bg-parchment/60 p-3">
            <p className="font-display text-base font-semibold text-sapphire-deep">{it.year ? `${it.year} · ` : ""}{it.title || it.name || it.q}</p>
            <p className="mt-1 line-clamp-2 font-sans text-xs text-charcoal/70">{it.body || it.note || it.a}</p>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <dl className="space-y-2 font-sans text-sm" data-testid="cms-preview">
      {Object.entries(data).map(([k, v]) => (
        <div key={k}><dt className="text-[11px] uppercase tracking-wider text-stonegrey">{k}</dt><dd className="text-sapphire-deep">{String(v)}</dd></div>
      ))}
    </dl>
  );
}
